import { useField, useFormikContext } from 'formik';

import styled from '@emotion/styled';

import {
  FieldErrorInfo,
  IInputField,
  Input,
  InputContainer,
  InputLabel,
  InputWrapper,
} from './FormField';

export const PercentageOnlyInputField: React.FC<
  IInputField & {
    maxLength?: number;
    showErrorLabel?: boolean;
    disabled?: boolean;
    allowHype?: boolean;
  }
> = ({
  label,
  lpiSrc,
  rpiSrc,
  className,
  maxLength,
  showErrorLabel = true,
  onValueChange,
  disabled,
  allowHype,
  ...props
}) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext<any>();

  // Format number with thousand separators
  const formatMoney = (value: string | number): string => {
    if (!value) return '';
    const numStr = value.toString().replace(/,/g, '');
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // Remove formatting to get raw number
  const unFormatMoney = (value: string): string => {
    return value.replace(/,/g, '');
  };

  const handleChange = (e: any) => {
    const { value } = e.target;
    const rawValue = unFormatMoney(value);

    const isValid = allowHype
      ? /^\d*\.?\d*$/.test(rawValue)
      : /^\d*$/.test(rawValue);

    if (isValid) {
      // Check if maxLength is specified and enforce the limit
      if (maxLength && rawValue.length > maxLength) {
        return; // Don't update if exceeding max length
      }
      setFieldValue(props.name, rawValue);
      if (onValueChange) {
        onValueChange(rawValue, props.name);
      }
    } else if (rawValue === '') {
      setFieldValue(props.name, '');
      if (onValueChange) {
        onValueChange('', props.name);
      }
    }
  };

  return (
    <InputWrapper className={className}>
      {label !== '' && (
        <InputLabel htmlFor={props.name || props.id}>{label}</InputLabel>
      )}
      <InputContainer>
        <WrappedInput
          {...field}
          {...props}
          disabled={disabled}
          value={formatMoney(field?.value ?? '')}
          onChange={(e) => handleChange(e)}
          // padding='10p'
        />
        <CurrencyIcon>%</CurrencyIcon>
      </InputContainer>
      {showErrorLabel && meta.touched && meta.error ? (
        <FieldErrorInfo>{meta.error.capitalize()}</FieldErrorInfo>
      ) : null}
    </InputWrapper>
  );
};

export default PercentageOnlyInputField;

const CurrencyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  margin-left: auto;
`;

const WrappedInput = styled(Input)`
  &:disabled {
    cursor: default;
    /* background-color: #f5f5f5; */
    /* color: #a9a9a9; */
  }
`;
